import React from 'react';
import { Container } from 'reactstrap';

export const FrontpageNoticeBanner = ({label, message, linkLabel, closeLabel, link}) => {
	const [dismissed, setDismissed] = React.useState(false);

	React.useEffect(() => {
		try {
			if (window.localStorage.getItem('frontpage-banner-dismissed') === '1') {
				setDismissed(true);
			}
		} catch (e) {
			// Ignore localStorage access issues.
		}
	}, []);

	if (dismissed) return null;

	if (!message) return null;

	const dismiss = () => {
		setDismissed(true);
		try {
			window.localStorage.setItem('frontpage-banner-dismissed', '1');
		} catch (e) {
			// Ignore localStorage access issues.
		}
	};

	return (
		<div className="ad_frontpage_notice_banner_wrap">
			<Container>
				<div className="ad_frontpage_notice_banner" role="status" aria-live="polite">
					<div className="ad_frontpage_notice_banner__content">
						{label ? <span className="ad_frontpage_notice_banner__label">{label}</span> : null}
						<span className="ad_frontpage_notice_banner__message">{message}</span>
						{link && link.length !== 0 ? (
							<React.Fragment>
								<a className="ad_frontpage_notice_banner__link" href={link} target='_blank'>{linkLabel}</a>
							</React.Fragment>
						) : null}
					</div>
					<button type="button" className="ad_frontpage_notice_banner__close" onClick={dismiss} aria-label={closeLabel}>
						<span aria-hidden="true">×</span>
					</button>
				</div>
			</Container>
		</div>
	);
};


// WEBPACK FOOTER //
// ./src/c/FrontpageBanner.js